/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Box, Modal, Stack, Grid, Button, Tooltip } from '@mui/material';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { getBorderColor } from '../../shared/utils';
import { convertUnitValues_flow, convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';
import './hpump.scss';

const checkFlowUnit = {};
const checkPressureUnit = {};

const RecircRoInput = (props) => {

  const { recircROvisiblePump, handleClosePump, recircRODetails, disabledStripperAndExplorerTab, clro_all_unitop, translateObject, setokbuttonFormAutoSave } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [disabled, setDisabled] = useState(true);
  const units = JSON.parse(localStorage.getItem('system-units')) || JSON.parse(localStorage.getItem('unit_set_dict')) || {};
  const previous_units = JSON.parse(localStorage.getItem('previous_units')) || {};
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);

  const [dischargeName, setDischargeName] = useState('Discharge Pressure');

  const defaultVals = {
    flowrate: 0.0,
    discharge_pressure: 0.000,
    inlet_pressure: 0.00,
    power: 0.00,
    auto_checked: true,
    pump_efficiency: 75,
    motor_efficiency: 96,
    vfd_efficiency: 97
  };

  const [inputState, setInputState] = useState(defaultVals);

  const fetchData = () => {
    const defaultVals = {
      flowrate: 0.0,
      discharge_pressure: 0.000,
      inlet_pressure: 0.00,
      power: 0.00,
      auto_checked: true,
      pump_efficiency: 75,
      motor_efficiency: 96,
      vfd_efficiency: 97
    };
    if (localStorage.getItem('recircRo-dict') && localStorage.getItem('recircRo-dict') !== '{}') {
      const formData_pump = JSON.parse(localStorage.getItem('recircRo-dict'));
      const storageData = formData_pump.RecircRO[`${recircRODetails.id}`] || {};
      const formData_hppump = JSON.parse(localStorage.getItem('ro_ouput_data'));

      if (formData_hppump && formData_pump.RecircRO[`${recircRODetails.id}`]) {
        const unitop_name = localStorage.getItem(recircRODetails.id);
        if (formData_hppump[unitop_name] && formData_hppump[unitop_name].output_user) {
          storageData.flowrate = formData_hppump[unitop_name].output_user.flow;
          storageData.discharge_pressure = formData_hppump[unitop_name].output_user.discharge_pressure;
          storageData.inlet_pressure = formData_hppump[unitop_name].output_user.inlet_pressure;
          storageData.power = formData_hppump[unitop_name].output_user.hp;
          storageData.pump_efficiency = formData_hppump[unitop_name].output_user.pump_efficiency.toFixed(2);
          // convert the flowrate, discharge_pressure, inlet_pressure and power value if user making any changes from system unit form -- START
          if (Object.keys(previous_units).length) {
            if (previous_units['Volume Flow'] !== units.flow) {
              storageData.flowrate = parseFloat(convertUnitValues_flow(formData_hppump[unitop_name].output_user.flow, previous_units['Volume Flow'], units.flow || units['Volume Flow']));
            }
            if (previous_units.Pressure !== units.pressure) {
              storageData.discharge_pressure = parseFloat(convertUnitValues_pressure(formData_hppump[unitop_name].output_user.discharge_pressure, previous_units.Pressure, units.pressure || units.Pressure));
            }
            if (previous_units.Pressure !== units.pressure) {
              storageData.inlet_pressure = parseFloat(convertUnitValues_pressure(formData_hppump[unitop_name].output_user.inlet_pressure, previous_units.Pressure, units.pressure || units.Pressure));
            }
            if (previous_units.Power !== units.power) {
              storageData.power = parseFloat(convertUnitValues_flow(formData_hppump[unitop_name].output_user.hp, previous_units.Power, units.power || units.Power));
            }
          }
          // convert the flowrate, discharge_pressure, inlet_pressure and power value if user making any changes from system unit form -- END
        }
      }
      if (Object.keys(storageData).length > 0) {
        setInputState(storageData);
        setDisabled(storageData.auto_checked);
      } else {
        setInputState(defaultVals);
      }
    }
  };

  useEffect(() => {
    fetchData();
    if (clro_all_unitop.length) {
      const data = clro_all_unitop.filter((ele) => {
        return recircRODetails.parentNode === ele.parentNode;
      });
      if (data.length > 0) {
        setDischargeName('Average Discharge Pressure');
      }
    }
  }, []);

  const checkValue = (e) => {
    if (e.target.checked === true) {
      setDisabled(e.target.checked);
      inputState.auto_checked = true;
    } else {
      setDisabled(false);
      inputState.auto_checked = false;
    }
    disabledStripperAndExplorerTab();
  };

  const getPumpName = () => {
    let pumpName = '';
    const local = localStorage.getItem(recircRODetails.id);
    if (local) {
      pumpName = ` - ${local}`;
    } else {
      pumpName = ` - Pump ${Number(get(recircRODetails, 'id', '').split('_')[1]) + 1}`;
    }
    return pumpName;
  };

  const handleInputChange = e => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    setInputState({
      ...inputState,
      [e.target.name]: Number(e.target.value),
    });
    disabledStripperAndExplorerTab();
  };

  function getUnitValue(item, value) {
    if (item === 'Pressure') {
      return units.pressure || value;
    } if (item === 'Flow') {
      return units.flow || value;
    } if (item === 'Power') {
      return units.power || value;
    }
  }

  const submitForm = () => {
    saveFormDataInLocalStorage({ record: inputState, type: 'RecircRO', id: recircRODetails.id, item: 'recircRo-dict' });
    checkFlowUnit[recircRODetails.id] = units.flow ? units.flow : 'gpm';
    checkPressureUnit[recircRODetails.id] = units.pressure ? units.pressure : 'atm';
    getBorderColor(recircRODetails.id);
    setokbuttonFormAutoSave(true);
    handleClosePump();
  };

  const handleCloseHp_Pump = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }

    handleClosePump();
  };

  const handleClosePumpModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleCloseHp_Pump(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleClosePump();
    };
  };

  return (
    <Modal
      hideBackdrop
      open={recircROvisiblePump}
      onClose={handleClosePumpModal}
      className="splitter-modal"
    >
      <Box>
        <Rnd
          default={{
            width: '40%',
            x: ((window.innerWidth / 2) - ((40 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((45 * (window.innerHeight / 100)) / 2))
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='25%'
          cancel='.no_drag'
          className='pump-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='pump-grid-container'>
            <Grid item xs={12} className='pump-header-grid'>
              <div className='pump-header-text rufusBld no_drag S_heading'>{`Pump Specification ${getPumpName()}`}</div>
              <div className='pump-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleClosePumpModal}
                    style={{ width: '14px', padding: '11px' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='pump-body-container sansW4SeLig'>
              <Grid container xs={12} spacing={2} style={{ margin: '12px 0px 0px 0px', padding: '0px 20px' }}>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Flow Rate')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='hppump-textbox no_drag'>
                          <input type="text" id="cancel-handle" className='Form_Input_design' name="flowrate" value={parseFloat(inputState.flowrate).toFixed(1)}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled />
                        </div>
                      </Grid>
                      <div item xs={2} className='hppump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>{getUnitValue('Flow', 'gpm')}</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject(dischargeName)}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='hppump-textbox no_drag'>
                          <input type="text" id="cancel-handle" name="discharge_pressure" className='Form_Input_design' value={parseFloat(inputState.discharge_pressure).toFixed(2)}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled />
                        </div>
                      </Grid>
                      <div className='hppump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>{getUnitValue('Pressure', 'atm')}</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Inlet Pressure')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='hppump-textbox no_drag'>
                          <input type="text" id="handle-cancel" name="inlet_pressure" className='Form_Input_design' value={parseFloat(inputState.inlet_pressure).toFixed(2)}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled />
                        </div>
                      </Grid>
                      <div className='hppump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>{getUnitValue('Pressure', 'atm')}</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Power')}</div>
                  </Grid>
                  <Grid item xs={7} style={{ display: 'flex', alignItems: 'center' }}>
                    <div className='hppump-textbox no_drag sansW4SeLig'>
                      <div className='no_drag L_Regular forground-text-primary'>{parseFloat(inputState.power).toFixed(2)} {getUnitValue('Power', 'kW')}</div>
                    </div>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Auto Efficiencies')}</div>
                  </Grid>
                  <Grid item xs={7}>
                    <div className='hppump-textbox sansW4SeLig'>
                      <input id="box2" className='no_drag' onChange={checkValue}
                        onFocus={e => e.target.select()} type="checkbox" value="Box2" checked={disabled} />
                    </div>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Pump Efficiency')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='hppump-textbox no_drag sansW4SeLig'>
                          <input type="text" id="handle-cancel" className='Form_Input_design' name="pump_efficiency" value={inputState.pump_efficiency}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled={disabled} />
                        </div>
                      </Grid>
                      <div className='hppump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>%</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('Motor Efficiency')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='hppump-textbox no_drag sansW4SeLig'>
                          <input type="text" id="handle-cancel" className='Form_Input_design' name="motor_efficiency" value={inputState.motor_efficiency}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled={disabled} />
                        </div>
                      </Grid>
                      <div className='hppump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>%</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12} sm={12} className='hppump-field-design' style={{ padding: '5px', display: 'flex', 'alignItems': 'center' }}>
                  <Grid item xs={5} md={5} sm={12}>
                    <div className="normal-font f-left ml-2 no_drag S_Bold">{translateObject('VFD Efficiency')}</div>
                  </Grid>
                  <Grid item xs={7} md={7} sm={12}>
                    <Grid container>
                      <Grid item xs={9}>
                        <div className='hppump-textbox no_drag sansW4SeLig'>
                          <input type="text" className='Form_Input_design' id="handle-cancel" name="vfd_efficiency" value={inputState.vfd_efficiency}
                            onChange={handleInputChange} onFocus={e => e.target.select()} disabled={disabled} />
                        </div>
                      </Grid>
                      <div className='hppump-filed-units'>
                        <div className='no_drag Form_Input_design_Units'>%</div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <div className="pump-button">
                  <Stack spacing={2} direction="row">
                    <Button variant="contained" size="small" className="M_Bold Secondary-Default_button "
                      onClick={handleClosePumpModal}> {translateObject('Cancel')} </Button>
                    <Button variant="contained" size="small" className="M_Bold Primary_Default_Button "
                      onClick={submitForm}>{translateObject('OK')}</Button>
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default RecircRoInput;
